import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  theme: {
    dark: JSON.parse(localStorage.getItem('dark')),
    themes: {
      light: {
        primary: '#009DFF',
        secondary: '#00C853',
        accent: colors.shades.black,
        success: '#4CAF50',
        info: '#2196F3',
        warning: colors.yellow.darken3,
        error: colors.red.accent3,
        appBar: colors.grey.lighten5,
        warningFont: colors.grey.darken2,
        buttons: '#FD9927'
      },
      dark: {
        primary: '#609C92',
        secondary: colors.grey.darken3,
        accent: '#FF4081',
        success: '#4CAF50',
        info: '#2196F3',
        warning: colors.yellow.darken2,
        error: '#FF5252',
        appBar: colors.grey.darken1,
        warningFont: colors.grey.darken2,
        buttons: '#FD9927'
      },
    },
  }
})

export default vuetify
